import { defineStore } from "pinia";
import DataSource from "devextreme/data/data_source";
import { ref } from "vue";
import { useDp3ListModel } from "@/stores/models/dp3-list-model";
import _ from "lodash";
export const useDp3ListStore = defineStore("dp3ListStore", () => {
  const isLoading = ref(false);
  const dataSourceDp3List = ref(
    new DataSource({
      requireTotalCount: true,
      store: useDp3ListModel().dp3ListCustomStore,
      filter: null,
      // summary: {
      //     totalItems: [
      //         {
      //             column: "biaya",  // The column to summarize
      //             summaryType: "sum",        // Supported types: 'sum', 'avg', 'min', 'max', 'count'
      //             displayFormat: "Total: {0}", // Format for the total row
      //         },
      //     ]
      // }
    })
  );

  const onPegawaiChanged = (e) => {
    const selectedPegawai = e.value; // You get the selected date here
    useDp3ListModel().setPegawaiFilter(selectedPegawai);
    dataSourceDp3List.value.reload();
  };

  const getData = async (filter) => {
    useDp3ListModel().setFilter(filter);
    useDp3ListModel().setTake("all");
    await dataSourceDp3List.value.reload();
    const totalKesetiaan = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.kesetiaan) || 0
    );
    const totalPrestasiKerja = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.prestasi_kerja) || 0
    );
    const totalTanggungJawab = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.tanggung_jawab) || 0
    );
    const totalKetaatan = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.ketaatan) || 0
    );
    const totalKejujuran = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.kejujuran) || 0
    );
    const totalKerjasama = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.kerjasama) || 0
    );
    const totalPrakarsa = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.prakarsa) || 0
    );
    const totalKepemimpinan = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.kepemimpinan) || 0
    );
    const totalJumlah = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.jumlah) || 0
    );
    const totalAvg = _.sumBy(
      dataSourceDp3List.value.items(),
      (item) => parseFloat(item.avg) || 0
    );
    return {
      data: dataSourceDp3List.value._items,
      totalCount: dataSourceDp3List.value._items.length,
      summary: [
        totalKesetiaan,
        totalPrestasiKerja,
        totalTanggungJawab,
        totalKetaatan,
        totalKejujuran,
        totalKerjasama,
        totalPrakarsa,
        totalKepemimpinan,
        totalJumlah,
        totalAvg,
      ],
    };
  };

  const state = ref(true);
  const refresh = () => {
    dataSourceDp3List.value.reload();
  };

  const initialized = () => {
    useDp3ListModel().setFilter(null);
    dataSourceDp3List.value.reload();
  };

  return {
    dataSourceDp3List,
    isLoading,
    refresh,
    initialized,
    state,
    onPegawaiChanged,
    getData,
  };
});
